export class NL {
    getTranslations() {
        return {
            btn_validate: 'OK',
            btn_cancel: 'Annuleren',
            btn_close: 'Sluiten',
            btn_add: 'Toevoegen',
            btn_delete: 'Verwijderen',
            msg_alert: 'Waarschuwing',
            msg_success: 'Gelukt',
            msg_confirm: 'Bevestig alstublieft',
            msg_input: 'Invoer',
            datahub_pickup_indicator: 'Indicatoren kiezen',
            datahub_fields: 'Velden',
            config_menu_loading: 'Menu wordt geladen...',
            editable_label_edit: 'Klik om te bewerken',
            editable_label_validate: 'Bevestigen',
            please_wait: 'Even geduld...',
            combobox_placeholder: 'Selecteer een optie',
            card_button_start: 'Starten',
            enter_credentials_to: 'Voer uw inloggegevens in voor toegang tot ',
        };
    }
}
